import { SET_CART_ITEM } from '../_constants/actionType';

export function setCartItems(items) {
  return {
    type: SET_CART_ITEM,
    items: items,
  };
}
